import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VendorManagementComponent } from './vendor-management.component';
import { ContractorHeadCountComponent } from './contractor-head-count/contractor-head-count.component';
import { DoughnutComponent } from './top-vendors/doughnut/doughnut.component';
import { VendorsListComponent } from './vendors-list/vendors-list.component';
import { ContractorsOrgViewComponent } from './contractors-org-view/contractors-org-view.component';
import { ContractorsManagersViewComponent } from './contractors-managers-view/contractors-managers-view.component';
import { SkillsComponent } from './skills/skills.component';
import { ExpiringContractsDashboardComponent } from './expiring-contracts-dashboard/expiring-contracts-dashboard.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { ContractorProfileComponent } from './contractor-profile/contractor-profile.component';
import { VendorProfileComponent } from './vendor-profile/vendor-profile.component';
import { InterviewsStatusComponent } from './vendor-profile/interviews-status/interviews-status.component';
import { VendorInfoComponent } from './vendor-profile/vendor-info/vendor-info.component';
import { ContractorVendorHeadCountComponent } from './vendor-profile/app-contractor-vendor-head-count/contractor-vendor-head-count.component';
import { PositionsComponent } from './positions/positions.component';
import { LearningDevelopmentModule } from './vendor-profile/learning-development/learning-development.module';

import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldProgressIndicatorModule } from '@emerald-angular/progress-indicator';
import { EmeraldMenuModule } from '@emerald-angular/menu';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';

import { VendorManagementFilterComponent } from '@shared/modals/vendor-management-filter/vendor-management-filter.component';
import { ChartModule } from 'primeng/chart';
import chartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { StrategicPartnershipComponent } from './vendor-profile/quarterly-feedback/strategic-partnership/strategic-partnership.component';
import { AuthGuard } from '@core/okta-auth.guard';
import { OpenPositionFilterComponent } from '@app/shared/modals/open-position-filter/open-position-filter.component';
import { PositionsFilterComponent } from '@app/shared/modals/positions-filter/positions-filter.component';
import { ContractorFilterComponent } from "../../shared/modals/contractor-filter/contractor-filter.component";
import { QuarterlyFeedbackComponent } from './vendor-profile/quarterly-feedback/quarterly-feedback.component';
import { RtoBarChartComponent } from './vendor-profile/quarterly-feedback/rto-bar-chart/rto-bar-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { PeopleMetricsComponent } from './people-metrics/people-metrics.component';
import { TimesheetCalendarComponent } from '../vendor-rep/timesheet-calendar/timesheet-calendar.component';
import { VendorListRtoDrillComponent } from './vendor-list-rto-drill/vendor-list-rto-drill.component';
import { EmeraldChipModule } from '@emerald-angular/chip';
import { VendorRTODrillFilterComponent } from '@app/shared/modals/vendor-rto-drill-filter/vendor-rto-drill-filter.component';
import { InterviewStatusWidgetComponent } from './interview-status-widget/interview-status-widget.component';
import { InterviewStatusWidgetFilterComponent } from '@app/shared/modals/interview-status-widget-filter/interview-status-widget-filter.component';
import { LearningDevelopmentComponent } from './vendor-profile/learning-development/learning-development.component';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { QuaterlyFeedbackComponent } from '@shared/components/quaterly-feedback/quaterly-feedback.component';
Chart.register(chartDataLabels);

const routes: Routes = [
  {
    path: 'vendor-management',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: VendorManagementComponent },
      { path: 'vendors-list', component: VendorsListComponent,
      },
      {
        path: 'vendors-profile/:vendorId/:vendorName',
        component: VendorProfileComponent,
      },
      { path: 'contractors-list', component: ContractorsOrgViewComponent },
      {
        path: 'rto-drill',
        component: VendorListRtoDrillComponent,
      },
      {
        path: 'contractor-profile/:id',
        component: ContractorProfileComponent,
      },
      { path: 'quarterly-feedback', component: QuaterlyFeedbackComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },

    ],
  },
];
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedModule,
    EmeraldButtonModule,
    EmeraldDropdownModule,
    EmeraldIconModule,
    EmeraldDesignSystemModule,
    EmeraldInputModule,
    EmeraldTabBarModule,
    EmeraldMenuModule,
    EmeraldDatepickerModule,
    EmeraldProgressIndicatorModule,
    FormsModule,
    VendorManagementFilterComponent,
    ChartModule,
    NgChartsModule,
    OpenPositionFilterComponent,
    ContractorFilterComponent,
    NgChartsModule,
    TimesheetCalendarComponent,
    LearningDevelopmentModule,
    EmeraldChipModule,
    VendorRTODrillFilterComponent,
    InterviewStatusWidgetFilterComponent,
    ModalWrapperComponent,
    ConfirmationDialogComponent
  ],
  exports: [
    DoughnutComponent,
    VendorManagementComponent,
    ContractorHeadCountComponent,
    ExpiringContractsDashboardComponent,
    PeopleMetricsComponent,
    LearningDevelopmentComponent,
    StrategicPartnershipComponent,
    ContractorProfileComponent
  ],
  declarations: [
    DoughnutComponent,
    VendorManagementComponent,
    ContractorHeadCountComponent,
    VendorsListComponent,
    ContractorsOrgViewComponent,
    ContractorsManagersViewComponent,
    SkillsComponent,
    ExpiringContractsDashboardComponent,
    TimesheetComponent,
    ContractorProfileComponent,
    VendorInfoComponent,
    VendorProfileComponent,
    ContractorVendorHeadCountComponent,
    PositionsComponent,
    PositionsFilterComponent,
    InterviewsStatusComponent,
    QuarterlyFeedbackComponent,
    RtoBarChartComponent,
    StrategicPartnershipComponent,
    RtoBarChartComponent,
    PeopleMetricsComponent,
    VendorListRtoDrillComponent,
    InterviewStatusWidgetComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VendorManagementModule {}